import { HxObject } from '@outlook/hxcore_web';
import { TraceErrorObject } from 'owa-trace';

export function handleHxObjectLoadResult<T extends HxObject>(
    loadResult: T | null,
    errorPrefix?: string
): T {
    if (!loadResult) {
        // We expect to sometimes see this failure when the ui is loading an item
        // which has been moved or deleted in another client but that hasn't
        // synced down to this client yet.
        const prefix = errorPrefix ? errorPrefix + ': ' : '';
        const error: TraceErrorObject = new Error(`${prefix}Failed to load hx object`);
        error.fetchErrorType = 'Expected';
        throw error;
    }
    return loadResult;
}
